import { createSelector } from '@ngrx/store';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getOneClickPricesValidatorParams = createSelector(
  getOneClickState,
  oneClick => {
    return {
      quantity: oneClick.quantityState.value,
      unit: oneClick.unitsSate,
      payment: oneClick.paymentsState,
      product: oneClick.productsState,
      blockedPrices: oneClick.profileState.blockedPrices,
    };
  },
);
